import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Skills } from "@/components/Skills";
import { Projects } from "@/components/Projects";
import { Labs } from "@/components/Labs";
import { Marquee } from "@/components/Marquee";
import { Experience } from "@/components/Experience";
import { Education } from "@/components/Education";
import { Certifications } from "@/components/Certifications";
import { Timeline } from "@/components/Timeline";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const NOISE_BG = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)'/%3E%3C/svg%3E")`;

function App() {
    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return undefined;
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen bg-ink font-body text-zinc-300">
            <div
                aria-hidden="true"
                className="pointer-events-none fixed inset-0 z-[90] opacity-[0.035]"
                style={{ backgroundImage: NOISE_BG }}
            />
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#111113",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#F4F4F5",
                    },
                }}
            />
            <Navbar />
            <main>
                <Hero />
                <About />
                <Skills />
                <Projects />
                <Labs />
                <Marquee />
                <Experience />
                <Education />
                <Certifications />
                <Timeline />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
